import type { ContrastFailure } from '@/api/types';

/** A contrast failure's identity: mode, pair and colours (SASATH-0346 N2). */
export function failureKey(f: ContrastFailure): string {
  return [f.mode, f.fg, f.bg, f.fgColor, f.bgColor].join('|');
}
